import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'
import { PutawayHubParamsType } from 'features/SupplyOrder/pages/PutawayHub/@types'
import { getAllLocations } from 'features/Location/services/location'
import {
  getPutawayHubListAPI,
  resetPutawayHubItemAPI,
} from 'features/SupplyOrder/services/putawayHub'

export const SLICE_NAME = 'putawayHub'

export const fetchPutawayHubList = createAsyncThunk(
  `${SLICE_NAME}/fetchPutawayHubList`,
  async (_params: PutawayHubParamsType, { rejectWithValue }) => {
    try {
      const response = await getPutawayHubListAPI(_params)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchLocations`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllLocations()
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchResetPutawayHubItem = createAsyncThunk(
  `${SLICE_NAME}/fetchResetPutawayHubItem`,
  async (
    props: {
      id: number
      onSuccess: (message: string) => void
    },
    { rejectWithValue },
  ) => {
    try {
      const { id, onSuccess } = props

      const res = await resetPutawayHubItemAPI(id, {
        id,
        action: 'REVERT',
      })

      onSuccess(res.data.message)

      return res.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
